// USER ENDPOINTS

export const login = '/user/login';
export const register = '/user/register';
export const createCompaign = '/campaign/create';
export const getCampaignsList = '/campaign/all';
export const getCompaignDetails = '/campaign/get';
export const extendBudget = '/campaign/extend';

export const getAudioData = '/audio/info';

export const getUserDetails = '/user/get/{id}';
